import ApiService from "@/core/services/api.service";
import {DELETE_NEWS} from "@/core/services/store/news/news.module";

export const CITIME_COMBO_CREATE = "citime_combo_create";
export const CITIME_COMBO_INDEX = "citime_combo_index";
export const CITIME_COMBO_DELETE = "citime_combo_delete";
export const EXTEND_DATElINE_CITIME = "citime/timelines/extend";
export const GET_TYPE_EXTEND = "citime/timelines/status-options";
export const GET_LIST_CITIME = "citime/timelines";
export const HANDLE_ERROR_PAYMENT = "citime/monthly-payments/confirm";
export const GET_RESULT_OPTION = "citime/timelines/late-payment-result-options";
export const HANDLE_SLOW_PAYMENT = "citime/timelines/process-late-payment";
export const GET_CONTRACT_CITIME = 'GET_CONTRACT_CITIME';
export const GET_CALL_CENTER_USER = 'GET_CALL_CENTER_USER';
export const ASSIGN_CONTRACT_CITIME = 'ASSIGN_CONTRACT_CITIME';
export const EXPORT_LIST_CITIME = 'citime/export-timelines';

const state = {};

const getters = {};
const actions = {
    [CITIME_COMBO_CREATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post('citime/citimes/save', payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [CITIME_COMBO_INDEX](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query('citime/citimes', payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [CITIME_COMBO_DELETE](context, id) {
        return new Promise(resolve => {
            ApiService.delete('citime/citimes', id).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                console.log(response)
            });
        })
    },
    [GET_CONTRACT_CITIME](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query('citime/contracts', payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [GET_CALL_CENTER_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query('citime/get-call-center-users', payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [ASSIGN_CONTRACT_CITIME](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`citime/contracts/${payload?.id}/assign`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [EXTEND_DATElINE_CITIME](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(EXTEND_DATElINE_CITIME, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [GET_TYPE_EXTEND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_TYPE_EXTEND).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [GET_LIST_CITIME](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_CITIME, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [EXPORT_LIST_CITIME](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_LIST_CITIME, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [HANDLE_ERROR_PAYMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(HANDLE_ERROR_PAYMENT, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [GET_RESULT_OPTION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_RESULT_OPTION, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },

    [HANDLE_SLOW_PAYMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(HANDLE_SLOW_PAYMENT, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
};
const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
